import { render, staticRenderFns } from "./guideDialog.vue?vue&type=template&id=0ccd90c8&scoped=true"
import script from "./guideDialog.vue?vue&type=script&lang=js"
export * from "./guideDialog.vue?vue&type=script&lang=js"
import style0 from "./guideDialog.vue?vue&type=style&index=0&id=0ccd90c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccd90c8",
  null
  
)

export default component.exports